import {
  Dialog,
  DialogTitle,
  IconButton,
  Box,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import WeekCalender from "./WeekCalender";
import MonthCalender from "./MonthCalender";

export default function CalendarModal({
  open,
  onClose,
  doctorId,
  dateForAppointment,
  reload,
  view = "week", // "week" | "month"
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: "12px",
          width: "95%",
          maxWidth: "1200px",
          height: "90vh",
        },
      }}
    >
      <DialogTitle
        sx={{
          backgroundColor: "#213360",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          color: "#fff",
        }}
      >
        Appointment Calendar
        <IconButton onClick={onClose}>
          <CloseIcon
            sx={{ color: "#FFFFFF", fontSize: { xs: "1.2rem", sm: "1.5rem" } }}
          />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 0 }}>
        <Box sx={{ p: 0, height: "calc(90vh - 64px)" }}>
          {view === "month" ? (
            <MonthCalender id={doctorId} date={dateForAppointment} />
          ) : (
            <WeekCalender
              id={doctorId}
              date={dateForAppointment}
              reload={reload}
            />
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Box display="flex" justifyContent="flex-end" gap={2} mt={2}>
          {/* Buttons */}

          <Button
            variant="contained"
            sx={{
              borderRadius: "10px",
              backgroundColor: "#121959",
              color: "#fff",
              fontSize: { xs: "0.75rem", sm: "0.875rem" },
              px: { xs: 1.5, sm: 2 },
              py: { xs: 0.5, sm: 1 },
              "&:hover": {
                backgroundColor: "#121959",
              },
            }}
            onClick={onClose}
            size="small"
          >
            Close
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
}
